export default __webpack_public_path__ + "static/media/Deanna_Jean_AHV_In_Moms_We_Trust.426329a7.jpg";